module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', [_c('a', {
    attrs: {
      "id": "ack"
    }
  })]), _c('a', {
    attrs: {
      "id": "ack"
    }
  }, [_c('div', {
    staticClass: "fmhT sgc-1"
  }, [_vm._v("\n    ACKNOWLEDGMENTS\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "fmtx1"
  }, [_vm._v("\n    Thank you to all my friends and family who lent tons of encouragement—along with their stomachs to taste all the food—while I wrote the cookbook. Also, a big thanks to the ever-helpful staff at the NYC Trader Joe’s locations.\n  ")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-06038bde","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/andr_9781569759516_oeb_ack_r1.vue
// module id = 66
// module chunks = 0